import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import TimeSlot from '../ReserveCom/TimeSlot';
import { LuCigaretteOff } from "react-icons/lu";
import { BrowserRouter, Routes, Route, NavLink, useParams, useLocation } from 'react-router-dom';
import { CreditCard, MapPin, Home, ArrowRight, CheckCircle, Building, User } from 'lucide-react';
import AlertModal from '../common/AlertModal';

const PaymentDeliverContainer = (props) => {
  const [main_deliver, setMainDeliver] = useState([])
  const [other_deliver, setOtherDeliver] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [alertModal, setAlertModal] = useState({ open: false, title: '', message: '' });
  const { id } = useParams();
  const [pay_method, setPayMethod] = useState(0);
  const [vanumber,setVaNumber] = useState('')
  const [vaaccount,setVaAccount] = useState('')
  const [branch_code,setBranchCode] = useState('')
  const [branch_name,setBranchName] = useState('')
  const [count,setCount] = useState(1)
  const location = useLocation();

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    console.log(selectedOption)
  };

  useEffect(() => {
    axiosInstance.get(`/payments`, {
      headers: {
        'uid': props.token,  // ここにアクセストークンをしっかり渡す
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setIsLoading(false)
        setMainDeliver(response.data.main_deliver)
        setOtherDeliver(response.data.other_deliver)
        setSelectedOption(String(response.data.main_deliver.id))
        console.log(response.data)
      });
  }, []);

  const postDeliver = () => {
        setIsLoading(true)
        if (pay_method == 1){
          axiosInstance.post(`/payments`, {id: id, deliver_id:selectedOption}, {
            headers: {
                'uid': props.token,  // ここにアクセストークンをしっかり渡す
                'Access-Control-Allow-Origin': '*'
            }
            })
            .then(response => {
                setIsLoading(false)
                if (response.data.response_data == 0) {
                  setAlertModal({ open: true, title: 'エラー', message: '失敗しました' })
                } else {
                  window.location.href = response.data.link_url
                }
            });
        } else {
          axiosInstance.post(`/payments/bank_payment`, {id: id, deliver_id:selectedOption}, {
            headers: {
                'uid': props.token,  // ここにアクセストークンをしっかり渡す
                'Access-Control-Allow-Origin': '*'
            }
            })
            .then(response => {
                setIsLoading(false)
                setCount(2)
                setVaNumber(response.data.bank_info.va_account_number)
                setVaAccount(response.data.bank_info.va_account_name)
                setBranchCode(response.data.bank_info.va_branch_code)
                setBranchName(response.data.bank_info.va_branch_name)
            });
        }
  }

  const handlePaymethodChange = (event) => {
    setPayMethod(event.target.value);
    console.log(selectedOption)
  };

if (isLoading) {
  return (
    <div>
      <div className="loader" style={{ width: '100px', height: '100px' }}></div>
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: '0%',
          height: '80px',
          background: '#FEFBF9',
          zIndex: '12',
        }}
      />
    </div>
  );
}
// インポートに追加

// JSXの差分（主要部分のみ）
return (
  <div className="sunny_container"  style={{paddingBottom:'120px'}}>
    {count == 1 ? (
      <div className="mypage_reservation payment_page">
        <div className="payment_steps">
          <div className="step completed">
            <CheckCircle className="step_icon" />
            <span>1</span>
          </div>
          <div className="step_line completed"></div>
          <div className="step active">
            <CreditCard className="step_icon" />
            <span>2</span>
          </div>
          <div className="step_line"></div>
          <div className="step">
            <ArrowRight className="step_icon" />
            <span>3</span>
          </div>
        </div>

        <div className="payment_section">
          <div className="section_header">
            <CreditCard className="section_icon" />
            <h1 className="mypage_reservation_h1">お支払い方法</h1>
          </div>
          
          <div className="payment_methods">
            <label className="payment_method_option">
              <input
                type="radio"
                name="pay_method"
                value={1}
                checked={pay_method === "1"}
                onChange={handlePaymethodChange}
              />
              <div className="method_content">
                <CreditCard className="method_icon" />
                <span>クレジットカード払い</span>
              </div>
            </label>
            
            <label className="payment_method_option">
              <input
                type="radio"
                name="pay_method"
                value={2}
                checked={pay_method === "2"}
                onChange={handlePaymethodChange}
              />
              <div className="method_content">
                <Building className="method_icon" />
                <span>銀行振込</span>
              </div>
            </label>
          </div>
        </div>

        <div className="payment_section">
          <div className="section_header">
            <MapPin className="section_icon" />
            <h1 className="mypage_reservation_h1">配送先住所一覧</h1>
          </div>
          
          <div className="delivery_addresses">
            <label className="delivery_address_option main_address">
              <input
                type="radio"
                name="options"
                value={String(main_deliver.id)}
                checked={selectedOption === String(main_deliver.id)}
                onChange={handleOptionChange}
              />
              <div className="address_content">
                <Home className="address_icon" />
                <div className="address_details">
                  <p className="address_zip">〒 {main_deliver.zip}</p>
                  <p className="address_main">{main_deliver.address}</p>
                  <p className="address_sub">{main_deliver.apartment}</p>
                </div>
              </div>
            </label>
            
            {other_deliver.map((option, index) => (
              <label key={index} className="delivery_address_option">
                <input
                  type="radio"
                  name="options"
                  value={String(option.id)}
                  checked={selectedOption === String(option.id)}
                  onChange={handleOptionChange}
                />
                <div className="address_content">
                  <MapPin className="address_icon" />
                  <div className="address_details">
                    <p className="address_zip">〒 {option.zip}</p>
                    <p className="address_main">{option.address}</p>
                    <p className="address_sub">{option.apartment}</p>
                  </div>
                </div>
              </label>
            ))}
          </div>
          
          <NavLink to={`/mypage/other/address/`}>
            <button className="address_management_button">
              <User className="button_icon" />
              配達先住所の登録・変更はこちらから
            </button>
          </NavLink>
        </div>
      {
        pay_method == 0 ?
          <div className="footer_content_page">
            <button className="modern_action_button" style={{background:'lightgrey',boxShadow:'none'}}>
              <span>次へ進む</span>
              <ArrowRight className="button_arrow" />
            </button>
          </div>
        :
          <div className="footer_content_page" onClick={() => postDeliver()}>
            <button className="modern_action_button">
              <span>次へ進む</span>
              <ArrowRight className="button_arrow" />
            </button>
          </div>
      }
      </div>
    ) : (
      <div className="bank_transfer_page">
        <div className="payment_steps">
          <div className="step completed">
            <CheckCircle className="step_icon" />
            <span>1</span>
          </div>
          <div className="step_line completed"></div>
          <div className="step completed">
            <CheckCircle className="step_icon" />
            <span>2</span>
          </div>
          <div className="step_line completed"></div>
          <div className="step">
            <ArrowRight className="step_icon" />
            <span>3</span>
          </div>
        </div>

        <div className="bank_info_card">
          <div className="bank_header">
            <Building className="bank_icon" />
            <h2>銀行振込</h2>
          </div>
          
          <div className="bank_details">
            <div className="bank_row">
              <span className="bank_label">金融機関：</span>
              <span className="bank_value">GMOあおぞらネット銀行</span>
            </div>
            <div className="bank_row">
              <span className="bank_label">支店名：</span>
              <span className="bank_value">{branch_name}</span>
            </div>
            <div className="bank_row">
              <span className="bank_label">支店コード：</span>
              <span className="bank_value">{branch_code}</span>
            </div>
            <div className="bank_row">
              <span className="bank_label">口座種別：</span>
              <span className="bank_value">普通口座</span>
            </div>
            <div className="bank_row">
              <span className="bank_label">口座番号：</span>
              <span className="bank_value">{vanumber}</span>
            </div>
            <div className="bank_row">
              <span className="bank_label">口座名義：</span>
              <span className="bank_value">{vaaccount}</span>
            </div>
          </div>

          <div className="payment_amount_card">
            <p className="amount_label">お振込金額</p>
            <p className="amount_value">¥{location.state.sum}</p>
          </div>

          <div className="bank_notice">
            <p>までお振込をお願いします。入金が確認でき次第、お薬を発送させていただきます。一度支払った振込先口座は再利用できませんのでご注意ください。</p>
            <p className="deadline"><strong>※支払い期限: 2週間</strong></p>
          </div>
        </div>
      </div>
    )}
    
    <AlertModal 
      open={alertModal.open}
      title={alertModal.title}
      message={alertModal.message}
      onClose={() => setAlertModal({ open: false, title: '', message: '' })}
    />
  </div>
);
};

export default PaymentDeliverContainer;
